module.exports = __webpack_public_path__ + "static/img/logo10.9db032e4.png";